export type RecordingScene = 'whiteboard' | 'screen' | 'speaker' | 'gallery';

/** Choose a scene for each frame, so changes during recording are reflected immediately. */
export function recordingScene(boardOpen: boolean, sharing: boolean, pinned: boolean, view: 'speaker' | 'gallery' | 'studio'): RecordingScene {
  if (boardOpen) return 'whiteboard';
  if (sharing) return 'screen';
  if (pinned || view === 'speaker') return 'speaker';
  return 'gallery';
}

export function recordingFit(vw: number, vh: number, x: number, y: number, w: number, h: number, fit: 'cover' | 'contain') {
  const ratio = fit === 'cover' ? Math.max(w / vw, h / vh) : Math.min(w / vw, h / vh);
  const width = vw * ratio, height = vh * ratio;
  return {x: x + (w - width) / 2, y: y + (h - height) / 2, width, height};
}
